export default __webpack_public_path__ + "static/media/signup_3.e7305611.jpg";